module.exports = __webpack_public_path__ + "static/media/4.fc59f778.png";